// @ts-nocheck

import styled from '@emotion/styled'

export const SingleUserTable = styled('section')`
  label: SingleUserTable;
  min-width: 740px;
  /* width: 80%; ?? */
  padding: 39px;
  border-bottom: 2px solid ${(props) => props.theme.backgrounds.backGround3};
  h4 {
    color: ${(props) => props.theme.colors.primary};
    padding: 15px 0;
  }
  ul {
    justify-content: end;
    li > a {
      color: ${(props) => props.theme.colors.primary};
    }
  }
`

export const SingleUserHeaderDiv = styled('div')`
  min-width: 740px;
  label: SingleUserHeaderDiv;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  background-color: ${(props) => props.theme.backgrounds.backGround3};
  padding: 9px 18px;
  div:last-child {
    width: 100px;
  }
  div:nth-child(2) {
    width: 70px;
  }
`

export const SingleUserRowDiv = styled.div`
  min-width: 740px;
  label: SingleUserRowDiv;
  display: flex;
  justify-content: space-between;
  padding: 0px 18px;
  margin-top: 12px;
  margin-bottom: 12px;
  border-bottom: 1px inset;
  align-items: baseline;
  font-size: 14px;
  div:last-child {
    width: 100px;
  }
  div:nth-child(2) {
    width: 70px;
  }
`

export const SingleUserColDiv = styled.div`
  label: SingleUserColDiv;
  white-space: nowrap;
  width: 240px;
  /* text-overflow: ellipsis;
  overflow: hidden; */
  height: 36px;
  display: flex;
  flex-direction: row-reverse;

  :first-child,
  :nth-child(2) {
    flex-direction: row;
  }
`
export const ActivityUserLink = styled('a')`
  label: ActivityUserLink;
  color: inherit;
  text-decoration: underline;
  &:hover {
    // @ts-expect-error
    color: ${(props) => props.theme.colors.secondary};
    cursor: pointer;
  }
`
export const ActivityInput = styled('div')`
  label: ActivityInput;
  display: flex;
  border-radius: 20px;
  // @ts-expect-error
  border: 2px solid #a5a5a5;
  margin: 12px 2px;
  padding: 3px 15px;
  color: #a5a5a5;
  position: relative;
  > input {
    border: 0px;
    outline: transparent;
  }
`
export const ActivityFilterBlock = styled('div')`
  label: ActivityFilterBlock;
  width: 278px;
  border: 1px inset;
  position: absolute;
  background: white;
  margin-top: -12px;

  button {
    background: transparent;
    border: none;
    border-bottom: 1px inset;
    width: 100%;
    text-align: left;
    padding: 6px 15px;
    :hover {
      opacity: 0.7;
    }
  }
`
export const FilterOption = styled('div')`
  label: FilterOption;
  display: flex;
  align-items: baseline;
  width: 615px;
  justify-content: space-between;
  > div {
    margin-top: -12px;
  }
`
export const SubHeadingTag = styled('div')`
  label: SubHeadingTag;
  display: flex;
  width: 605px;
  justify-content: space-between;
  /* width: 800px; */
  h5 {
    color: #666;
    width: 280px;
  }
`
